export default __webpack_public_path__ + "static/media/denofthecrowmen.aab2e6fc.jpg";